@if (isLoading) {
  <div class="xi-loader-container__center">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}
<ng-container *transloco="let t">
  <div class="insight-feed">
    <div class="insight-feed__list">
      @if (pagedInsights().length) {
        <span (click)="onSelectAllClicked($event)" class="insight-feed__select-all">
          {{
            !insightFeedSelectAll
              ? t('widgets.ai-insights.select-all')
              : t('widgets.ai-insights.select-none')
          }}
        </span>
      }

      @for (insight of pagedInsights(); track insight.insight_id) {
        <app-insight-card
          [insight]="insight"
          [insightFeed]="true"
          [isReadOnly]="widgetComponent.isReadOnly"
          [options]="insightCardOptions()"
          [selectedForDownload]="isInsightSelected(insight)"
          (selectionChange)="onInsightSelectionChange($event)"
          (publishInsight)="onPublishInsight($event)"
        ></app-insight-card>
      }

      @if (insightResponse()?.length) {
        <mat-paginator
          [disabled]="isLoading || !insightResponse().length"
          [length]="insightResponse().length"
          [pageIndex]="pageIndex()"
          [pageSize]="pageSize()"
          [pageSizeOptions]="pageSizeOptions"
          [hidePageSize]="false"
          class="insight-feed__paginator"
          (page)="onPageChanged($event)"
        ></mat-paginator>
      }
    </div>
    @if (!insightResponse() || insightResponse().length < 1) {
      <div class="insight-feed__empty" [class.insight-feed__empty--loading]="isLoading">
        <span>{{ t('widgets.ai-insights.no-insights') }}</span>
      </div>
    }
  </div>
</ng-container>
